import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconArrowUp(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M5.293 11.707a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L13 7.414V19a1 1 0 1 1-2 0V7.414l-4.293 4.293a1 1 0 0 1-1.414 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
